"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewAGTestCaseData = exports.AGTestCase = void 0;
var ag_test_command_1 = require("./ag_test_command");
var http_client_1 = require("./http_client");
var utils_1 = require("./utils");
var AGTestCaseCoreData = /** @class */ (function () {
    function AGTestCaseCoreData(args) {
        this.pk = args.pk;
        this.name = args.name;
        this.ag_test_suite = args.ag_test_suite;
        this.internal_admin_notes = args.internal_admin_notes;
        this.staff_description = args.staff_description;
        this.student_description = args.student_description;
        this.normal_fdbk_config = args.normal_fdbk_config;
        this.ultimate_submission_fdbk_config = args.ultimate_submission_fdbk_config;
        this.past_limit_submission_fdbk_config = args.past_limit_submission_fdbk_config;
        this.staff_viewer_fdbk_config = args.staff_viewer_fdbk_config;
        this.last_modified = args.last_modified;
    }
    return AGTestCaseCoreData;
}());
var AGTestCase = /** @class */ (function (_super) {
    __extends(AGTestCase, _super);
    function AGTestCase(args) {
        var _this = _super.call(this, args) || this;
        _this.ag_test_commands = args.ag_test_commands.map(function (data) { return new ag_test_command_1.AGTestCommand(data); });
        return _this;
    }
    AGTestCase.subscribe = function (observer) {
        AGTestCase._subscribers.add(observer);
    };
    AGTestCase.unsubscribe = function (observer) {
        AGTestCase._subscribers.delete(observer);
    };
    AGTestCase.get_all_from_ag_test_suite = function (ag_test_suite_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/ag_test_suites/" + ag_test_suite_pk + "/ag_test_cases/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.map(function (data) { return new AGTestCase(data); })];
                }
            });
        });
    };
    AGTestCase.get_by_pk = function (ag_test_case_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/ag_test_cases/" + ag_test_case_pk + "/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new AGTestCase(response.data)];
                }
            });
        });
    };
    AGTestCase.create = function (ag_test_suite_pk, data) {
        return __awaiter(this, void 0, void 0, function () {
            var response, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().post("/ag_test_suites/" + ag_test_suite_pk + "/ag_test_cases/", data)];
                    case 1:
                        response = _a.sent();
                        result = new AGTestCase(response.data);
                        AGTestCase.notify_ag_test_case_created(result);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    AGTestCase.notify_ag_test_case_created = function (ag_test_case) {
        var e_1, _a;
        try {
            for (var _b = __values(AGTestCase._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_ag_test_case_created(ag_test_case);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    AGTestCase.prototype.copy = function (new_name) {
        return __awaiter(this, void 0, void 0, function () {
            var new_case_response, new_case, _a, _b, cmd, cmd_response, e_2_1;
            var e_2, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().post("/ag_test_suites/" + this.ag_test_suite + "/ag_test_cases/", {
                            name: new_name,
                            internal_admin_notes: this.internal_admin_notes,
                            staff_description: this.staff_description,
                            student_description: this.student_description,
                            normal_fdbk_config: this.normal_fdbk_config,
                            ultimate_submission_fdbk_config: this.ultimate_submission_fdbk_config,
                            past_limit_submission_fdbk_config: this.past_limit_submission_fdbk_config,
                            staff_viewer_fdbk_config: this.staff_viewer_fdbk_config,
                        })];
                    case 1:
                        new_case_response = _d.sent();
                        new_case = new AGTestCase(new_case_response.data);
                        _d.label = 2;
                    case 2:
                        _d.trys.push([2, 7, 8, 9]);
                        _a = __values(this.ag_test_commands), _b = _a.next();
                        _d.label = 3;
                    case 3:
                        if (!!_b.done) return [3 /*break*/, 6];
                        cmd = _b.value;
                        return [4 /*yield*/, http_client_1.HttpClient.get_instance().post("/ag_test_cases/" + new_case.pk + "/ag_test_commands/", utils_1.filter_keys(cmd, ag_test_command_1.AGTestCommand.EDITABLE_FIELDS))];
                    case 4:
                        cmd_response = _d.sent();
                        new_case.ag_test_commands.push(new ag_test_command_1.AGTestCommand(cmd_response.data));
                        _d.label = 5;
                    case 5:
                        _b = _a.next();
                        return [3 /*break*/, 3];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        e_2_1 = _d.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 9];
                    case 8:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 9:
                        AGTestCase.notify_ag_test_case_created(new_case);
                        return [2 /*return*/, new_case];
                }
            });
        });
    };
    AGTestCase.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().patch("/ag_test_cases/" + this.pk + "/", utils_1.filter_keys(this, AGTestCase.EDITABLE_FIELDS))];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, new AGTestCase(response.data));
                        AGTestCase.notify_ag_test_case_changed(this);
                        return [2 /*return*/];
                }
            });
        });
    };
    AGTestCase.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var last_modified, reloaded;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        last_modified = this.last_modified;
                        return [4 /*yield*/, AGTestCase.get_by_pk(this.pk)];
                    case 1:
                        reloaded = _a.sent();
                        utils_1.safe_assign(this, reloaded);
                        if (last_modified !== this.last_modified) {
                            AGTestCase.notify_ag_test_case_changed(this);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AGTestCase.notify_ag_test_case_changed = function (ag_test_case) {
        var e_3, _a;
        try {
            for (var _b = __values(AGTestCase._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_ag_test_case_changed(ag_test_case);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    AGTestCase.prototype.delete = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().delete("/ag_test_cases/" + this.pk + "/")];
                    case 1:
                        _a.sent();
                        AGTestCase.notify_ag_test_case_deleted(this);
                        return [2 /*return*/];
                }
            });
        });
    };
    AGTestCase.notify_ag_test_case_deleted = function (ag_test_case) {
        var e_4, _a;
        try {
            for (var _b = __values(AGTestCase._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_ag_test_case_deleted(ag_test_case);
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
    };
    AGTestCase.get_order = function (ag_test_suite_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/ag_test_suites/" + ag_test_suite_pk + "/ag_test_cases/order/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    AGTestCase.update_order = function (ag_test_suite_pk, ag_test_case_order) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().put("/ag_test_suites/" + ag_test_suite_pk + "/ag_test_cases/order/", ag_test_case_order)];
                    case 1:
                        response = _a.sent();
                        AGTestCase.notify_ag_test_case_order_updated(ag_test_suite_pk, response.data);
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    AGTestCase.notify_ag_test_case_order_updated = function (ag_test_suite_pk, ag_test_case_order) {
        var e_5, _a;
        try {
            for (var _b = __values(AGTestCase._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_ag_test_cases_order_changed(ag_test_suite_pk, ag_test_case_order);
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_5) throw e_5.error; }
        }
    };
    AGTestCase._subscribers = new Set();
    AGTestCase.EDITABLE_FIELDS = [
        'name',
        'ag_test_suite',
        'internal_admin_notes',
        'staff_description',
        'student_description',
        'normal_fdbk_config',
        'ultimate_submission_fdbk_config',
        'past_limit_submission_fdbk_config',
        'staff_viewer_fdbk_config',
    ];
    return AGTestCase;
}(AGTestCaseCoreData));
exports.AGTestCase = AGTestCase;
var NewAGTestCaseData = /** @class */ (function () {
    function NewAGTestCaseData(args) {
        this.name = args.name;
        this.internal_admin_notes = args.internal_admin_notes;
        this.staff_description = args.staff_description;
        this.student_description = args.student_description;
        this.normal_fdbk_config = args.normal_fdbk_config;
        this.ultimate_submission_fdbk_config = args.ultimate_submission_fdbk_config;
        this.past_limit_submission_fdbk_config = args.past_limit_submission_fdbk_config;
        this.staff_viewer_fdbk_config = args.staff_viewer_fdbk_config;
    }
    return NewAGTestCaseData;
}());
exports.NewAGTestCaseData = NewAGTestCaseData;
//# sourceMappingURL=ag_test_case.js.map